module.exports = __webpack_public_path__ + "img/tennis.411e09b7.svg";